import React, { useState } from 'react'
import { useCookies } from 'react-cookie';
import {
  Slider,
  Switch,
  // FormControl,
  // MenuItem,
  // InputLabel,
  // Select,
  // Radio,
  // RadioGroup,
  // FormControlLabel,
  // Button,
  Divider,
} from "@mui/material";
import debounce from "../../../../utils/debounce";
import BinaryClassResult from '../../components/BinaryClassResult';
import { connect } from 'react-redux';
import { updateAlert } from '../../redux/actions';

function BinaryClass({ result, groundTruth, setGroundTruth, user, files }) {

  const [cookies, setCookie] = useCookies([""]);
  // eslint-disable-next-line
  const [filter, setFilter] = useState(1);
  const [filteredFilenames, setFilteredFilenames] = useState([]);
  const [height, setHeight] = useState(
    document.cookie.includes("acceptedCookiePolicy=true") && cookies["height"] !== undefined ? parseInt(cookies["height"]) : 80);
  const [grid, setGrid] = useState(
    document.cookie.includes("acceptedCookiePolicy=true") && cookies["grid"] !== undefined ? parseInt(cookies["grid"]) : 1
  );
  // eslint-disable-next-line
  const [NPP, setNPP] = useState(
    document.cookie.includes("acceptedCookiePolicy=true") && cookies["npp"] !== undefined ? parseInt(cookies["npp"]) : 5
  );


  const handleFilterFilename = (fn) => {
    const tmpfn = [...filteredFilenames];
    if (filteredFilenames.indexOf(fn) === -1) {
      tmpfn.push(fn);
      setFilteredFilenames(tmpfn);
    } else {
      tmpfn.splice(filteredFilenames.indexOf(fn), 1);
      setFilteredFilenames(tmpfn);
    }
  };

  // const handleClearFilter = () => {
  //   setFilteredFilenames([]);
  //   setFilter(1);
  // };

  const setHeightCookie = (value) => {
    if (document.cookie.includes("acceptedCookiePolicy=true")) {
      setCookie("height", value * 2, {
        expires: new Date(new Date().getTime + 2 * 3600 * 1000),
      });
    }

  };

  const handleHeightCookie = debounce(setHeightCookie);

  const handleHeightChange = (value) => {
    setHeight(value * 2);
    if (document.cookie.includes("acceptedCookiePolicy=true")) {
      handleHeightCookie(value);
    }
  };

  const handleGridChange = (e) => {
    const checked = e.target.checked;
    setGrid(checked ? 1 : 0);
    if (document.cookie.includes("acceptedCookiePolicy=true")) {
      setCookie("grid", checked ? 1 : 0, {
        expires: new Date(new Date().getTime + 2 * 3600 * 1000),
      });
    }

  };

  // const handleNPPChange = (e) => {
  //   const value = e.target.value;
  //   setNPP(value);
  //   if (document.cookie.includes("acceptedCookiePolicy=true")) {
  //     setCookie("npp", value, {
  //       expires: new Date(new Date().getTime + 2 * 3600 * 1000),
  //     });
  //   }

  // };

  // const handleRadioChange = (e) => {
  //   const choice = parseInt(e.target.value);
  //   const values = JSON.parse(result.value).results;
  //   const filenames = JSON.parse(result.fileName).filenames;
  //   setFilter(choice);
  //   const tmpfn = [];
  //   if (choice === 1) {
  //   } else if (choice === 2) {
  //     // pos
  //     for (let i = 0; i < values.length; i++) {
  //       if (values[i] === 1) {
  //         tmpfn.push(filenames[i]);
  //       }
  //     }
  //   } else if (choice === 3) {
  //     // neg
  //     for (let i = 0; i < values.length; i++) {
  //       if (values[i] === 0) {
  //         tmpfn.push(filenames[i]);
  //       }
  //     }
  //   } else if (choice === 4) {
  //     // corr
  //     if (groundTruth.length > 0) {
  //       for (let i = 0; i < groundTruth.length; i++) {
  //         const index = filenames.indexOf(groundTruth[i].filename);
  //         if (index > -1) {
  //           if (Array.isArray(values[index])) {
  //             const tmp = [];
  //             for (let j = 0; j < values[index].length; j++) {
  //               if (values[index][j] === groundTruth[i].groundTruth[j]) {
  //                 tmp.push(values[index][j]);
  //               }
  //             }
  //             if (tmp.length > 0) {
  //               tmpfn.push(filenames[index]);
  //             }
  //           } else {
  //             if (values[index] === groundTruth[i].groundTruth[0]) {
  //               tmpfn.push(filenames[index]);
  //             }
  //           }
  //         }
  //       }
  //     } else {
  //       setFilter(1);
  //       handleAlert("error", "Please provide labels first!", 3000);
  //     }
  //   } else {
  //     // incorr
  //     if (groundTruth.length > 0) {
  //       for (let i = 0; i < groundTruth.length; i++) {
  //         const index = filenames.indexOf(groundTruth[i].filename);
  //         if (index > -1) {
  //           if (Array.isArray(values[index])) {
  //             const tmp = [];
  //             for (let j = 0; j < values[index].length; j++) {
  //               if (values[index][j] !== groundTruth[i].groundTruth[j]) {
  //                 tmp.push(values[index][j]);
  //               }
  //             }
  //             if (tmp.length > 0) {
  //               tmpfn.push(filenames[index]);
  //             }
  //           } else {
  //             if (values[index] !== groundTruth[i].groundTruth[0]) {
  //               tmpfn.push(filenames[index]);
  //             }
  //           }
  //         }
  //       }
  //     } else {
  //       setFilter(1);
  //       handleAlert("error", "Please provide labels first!", 3000);
  //     }
  //   }

  //   setFilteredFilenames(tmpfn);
  // };

  return (
    <>
      <div className="uploaded-files">
        Uploaded files {result.dataSaved ? "(saved)" : "(unsaved)"}:
      </div>
      <div className="res-file-names">
        {JSON.parse(result.fileName).filenames.map((filename, index) => {
          return (
            <div
              className={`res-filename${filteredFilenames.indexOf(filename) === -1
                ? ""
                : "-selected"
                }`}
              key={index}
              onClick={() => handleFilterFilename(filename)}
            >
              {filename}
            </div>
          );
        })}
      </div>

      {result.dataSaved && (
        <div className="res-adj-height">
          Adjust plot height:
          <Slider
            color="primary"
            defaultValue={
              cookies["height"] === undefined
                ? 40
                : parseInt(cookies["height"]) / 2
            }
            getAriaValueText={handleHeightChange}
          />
        </div>
      )}

      <div className="plot-ctrl">
        {result.dataSaved && (
          <div className="grid-switch">
            Grid
            <Switch
              color="primary"
              onChange={handleGridChange}
              checked={grid ? true : false}
            />
          </div>
        )}


        {/* <div
          className="num-plots-per-page"
          style={{ marginLeft: result.dataSaved ? "30px" : "0px" }}
        >
          <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
            <InputLabel sx={{ marginLeft: "10px" }}>
              Number per page
            </InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={NPP}
              defaultValue={5}
              onChange={handleNPPChange}
              // options={[
              //     { value: 5, label: 5 },
              //     { value: 10, label: 10 },
              //     { value: 15, label: 15 }
              // ]}
              label="Number per page"
              style={{ marginLeft: "10px", width: 150 }}
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={15}>15</MenuItem>
            </Select>
          </FormControl>
        </div> */}

        {/* <div className="res-sig-filter">
          Model results:
          <FormControl>
            <RadioGroup
              row
              onChange={handleRadioChange}
              value={filter}
              style={{ marginLeft: "10px" }}
            >
              <FormControlLabel
                value={1}
                control={<Radio size="small" />}
                label={<div className="radio-label">No filter</div>}
              />
              <FormControlLabel
                value={2}
                control={<Radio size="small" />}
                label={<div className="radio-label">Positive</div>}
              />
              <FormControlLabel
                value={3}
                control={<Radio size="small" />}
                label={<div className="radio-label">Negative</div>}
              />
              {groundTruth.length > 0 ? (
                <>
                  <FormControlLabel
                    value={4}
                    control={<Radio size="small" />}
                    label={<div className="radio-label">Correct</div>}
                  />
                  <FormControlLabel
                    value={5}
                    control={<Radio size="small" />}
                    label={<div className="radio-label">Incorrect</div>}
                  />
                </>
              ) : null}
            </RadioGroup>
          </FormControl>
        </div> */}

        {/* <div
          className={`res-clear-filter${filteredFilenames.length === 0 ? "-none" : ""
            }`}
        >
          <Button variant="outlined" color="error" onClick={handleClearFilter}>
            Clear
          </Button>
        </div> */}
      </div>

      <Divider />
      <div className="bcs">
        <BinaryClassResult
          height={height}
          grid={grid}
          npp={NPP}
          filter={filter}
          stringResults={result.value}
          dataSaved={result.dataSaved}
          groundTruth={groundTruth}
          stringFilenames={
            filteredFilenames.length === 0
              ? JSON.stringify(JSON.parse(result.fileName).filenames)
              : JSON.stringify(filteredFilenames)
          }
          files={files}
          resultId={result.id}
          uid={user.id}
          setGroundTruth={setGroundTruth}
        />
      </div>
    </>
  )
};

const mapStateToProps = (state, props) => {
  console.log(state)
  return {
    result: props.result,
    groundTruth: props.groundTruth,
    setGroundTruth: props.setGroundTruth,
    files: props.files,
    setCM: props.setCM,
    user: state.main.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BinaryClass)
